export const SUPPLIERS_ENDPOINT = `https://${process.env.NEXT_PUBLIC_SUPPLIERS_GATEWAY_DOMAIN_NAME}`;
